export default __webpack_public_path__ + "static/media/rubik-v12-latin-900.c0bc6286.woff";